<template>
    <console-layout width="100%" max-width="1280">

        <console-title>
            <span>FAQ</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary.totalCount.format() }}</span>
                <v-spacer />
                <span></span>
            </v-layout>
    
            <v-data-table :items="faqs" :headers="faqsHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template #[`item.answer`]="{item}">
                    <p v-html="item.answer.replace(/\n/g, '<br/>')" class="ma-0" />
                </template>
                <template #[`item.actions`]="{item}">
                    <v-icon small class="mx-1" @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon v-if="$hasScope(['root', 'admin'])" small class="mx-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>
        </console-body>

        <v-btn v-if="$hasScope(['root', 'admin'])" fab fixed bottom right color="accent" :to="`${$route.path}/create`"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            faqs: [],
            faqsHeaders: [
                { text: "no", value: "no", align: "center", /* width: 10 */ },
                { text: "질문", value: "question", align: "center", /* width: 10 */ },
                { text: "actions", value: "actions", align: "center", /* width: 10 */ },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "질문", value: "question" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, faqs } = await api.console.center.faqs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.faqs = faqs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        edit(faq){
            this.$router.push(`/console/center/faqs/${faq._id}`)
        },
        async remove(faq){
            if(confirm("삭제하시겠습니까?")){
                await api.console.center.faqs.delete(faq);
                alert("삭제되었습니다");
                await this.search();
            }
        },
        // async excel(){
        //     let { faqs } = await api.console.center.faqs.gets({ headers: { limit: 0 }, params: this.filter });

        //     let rows = [];
        //     faqs.forEach(faq => {
        //         rows.push({
        //             "no": faq.no,
        //             "이름": faq.name,
        //         });
        //     });

        //     let workbook = new XLSX.utils.book_new();
        //     let worksheet = XLSX.utils.json_to_sheet(rows);

        //     XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
        //     XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        // }
    }
}
</script>